/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import AdminLayout from "./components/admin/AdminLayout";
import MainLayout from "./components/layout/MainLayout";
import UnauthorizedPage from "./pages/Unauthorized";
import NotFoundPage from "./pages/NotFoundPage";
import MiPerfil from "./components/user/MiPerfil";

/**
 * Componente principal de la aplicación.
 * 
 * Punto central que renderiza toda la aplicación.
 * Define todas las rutas de la aplicación y sus protecciones.
 * Utiliza react-router-dom para la navegación y ProtectedRoute
 * para control de acceso basado en autenticación y roles.
 */
function App() {
  return (
        <Router>
          <Routes>

            {/* Ruta principal: Página de inicio del directorio */}
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              } 
            />

             {/* Ruta de administración: Requiere rol ROLE_ADMIN */}
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute requiredRole="ROLE_ADMIN" blockMobile={true}>
                  <AdminLayout />
                </ProtectedRoute>
              } 
            />

            {/* Ruta de error 403: Acceso no autorizado */}
            <Route path="/unauthorized" element={<UnauthorizedPage />} />

	    <Route path="/mi-perfil" element={<MiPerfil />} />            

            {/* Ruta comodín: Error 404 para rutas no encontradas */}
            <Route path="*" element={<NotFoundPage />} />

          </Routes>
        </Router>
  );
}

export default App;


